import { useReactiveVar } from '@apollo/client';
import { Meta, theme } from 'aimo-ui';
import FlatListCustom from 'components/sheets/FlatListCustom';
import AccountContext from 'context/AccountContext';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { LatLng } from 'react-native-maps';
import { recentZonesOrChargers } from 'states/persistInStorage';
import { Divider } from 'styles/CommonLayoutStyles';
import { parkMapParkzoneFilter } from 'utils/parkUtils';
import { testIdentifiers } from 'utils/testIdentifiers';
import SearchItem from '../SearchItem';
import { MarginView, Row } from '../styles/styles';

type RecentSearchesListProps = {
  currentLocation: LatLng | null;
  withLTP?: boolean;
};

const ItemSeparator = () => <Divider marginVertical={10} />;
const ListFooter = () => <MarginView />;

const RecentSearchesList: React.FC<RecentSearchesListProps> = ({
  currentLocation,
  withLTP,
}) => {
  const { t } = useTranslation();
  const {
    customer: { householdBenefits, permits },
  } = useContext(AccountContext);

  const recentZonesOrChargersArray = useReactiveVar(recentZonesOrChargers);
  const userRecentZonesOrChargers = parkMapParkzoneFilter(
    recentZonesOrChargersArray || [],
    householdBenefits,
    permits
  );

  if (userRecentZonesOrChargers.length === 0) {
    return null;
  }

  return (
    <>
      <Row mt={15} mb={16}>
        <Meta
          {...testIdentifiers('recent-searches-label')}
          color={theme.colors.gray300}>
          {t('search.recentZonesAndChargers')}
        </Meta>
      </Row>
      <FlatListCustom
        data={userRecentZonesOrChargers}
        removeClippedSubviews={false}
        ItemSeparatorComponent={ItemSeparator}
        renderItem={({ item }) => (
          <SearchItem
            item={item}
            currentLocation={currentLocation}
            withLTP={withLTP}
          />
        )}
        ListFooterComponent={ListFooter}
        keyExtractor={(item, index) => `${item?.uid}-${index}`}
      />
    </>
  );
};

export default RecentSearchesList;
